import moment from 'moment'

export default {
  initialized: false,
  user: {},
  currentClientId: null,
  availableClients: [],
  availableClientsById: {},
  availableServicesById: {},
  availableServices: [],
  currentClient: {},
  availableCaseStatuses: [],
  availableCaseStatusesByValue: {},
  availableCaseCreationOrderStatuses: [],
  availableCaseCreationOrderStatusesByValue: {},
  servicesByClients: {},
  availableUsers: [],
  availableUsersById: {},
  cases: {
    pagination: {
      rowsPerPage: 40,
      page: 1
    },
    filters: {
      createdFrom: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      createdTo: moment().format('YYYY-MM-DD'),
      fulltextSearchString: null,
      statuses: [],
      serviceIds: [],
      specialistIds: []
    },
    creationDateRangeFilterOptions: {
      startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      format: 'YYYY-MM-DD'
    },
    items: [],
    totalItems: 0,
    loading: false
  },
  caseCreationOrders: {
    pagination: {
      rowsPerPage: 40,
      page: 1
    },
    filters: {
      createdFrom: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      createdTo: moment().format('YYYY-MM-DD'),
      statuses: []
    },
    creationDateRangeFilterOptions: {
      startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      format: 'YYYY-MM-DD'
    },
    items: [],
    totalItems: 0,
    loading: false,
    progressByOrders: {},
    scanning: false
  },
  createCase: {
    progress: false,
    progressByActions: {},
    materialsFormValue: null,
    data: null,
    form: {
      valid: null,
      errorMessages: [],
      data: {
        patientName: null,
        patientGender: null,
        patientBirthday: null,
        patientAddress: null,
        patientPhone: null,
        patientEmail: null,
        omi_policy_number: null,
        clinicalData: null,
        examination: null,
        receiveMaterialMethod: [],
        diagnosis: null,
        clientSpecialist: null,
        services: [],
        materials: {},
        files: [],
        externalId: null,
        externalLabel: null
      }
    }
  },
  updateCaseCreationOrder: {
    progress: false,
    progressByActions: {},
    materialsFormValue: null,
    data: null,
    form: {
      valid: null,
      errorMessages: [],
      data: null
    }
  },
  dpURL: 'http://app.dpathology.ru/',
}
